import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {ListGroup} from 'react-bootstrap';
import './Sidebar.css'

class Sidebar extends Component {
  render() {
    return (
      <div>
        <br/>
        <br/>
        <br/>
       <div class="sidebar-modern-inner">
                            <div class="block-title has-arrow sidebar-header">
                                <h5><a href="http://templatecycle.com/demo/bootclassified-4.4/dist/category.html?category=Cars&amp;location=AL&amp;fbclid=IwAR01uB6EHGbFzl6NlELQTDG4MhWTMH5jXh2PPiijsNR0HVT2IwGr3WmulSs#">All Categories</a></h5>
                            </div>
                            <div class="block-content categories-list  list-filter ">
                                <ul class=" list-unstyled">
                                    <li><Link to ='/fastFood'><span class="title">Fast Food</span><span class="count">&nbsp;</span></Link>
                                    </li>
                                    <li><Link to ='/drinks'><span class="title">Drinks </span><span class="count">&nbsp;</span></Link></li>
                                    <li><Link to ='/snacks'><span class="title">Snacks </span><span class="count">&nbsp;</span></Link></li>
                                  </ul>
                            </div> 

                            <div class="block-title has-arrow ">
                                <h5>Location</h5>
                            </div>
                            <div class="block-content categories-list  list-filter ">
                                <ul class="list-unstyled">
                
                                    <li><Link to ='/'><span class="title"> Australia</span></Link> </li>
                                    <li><Link to ='/'><span class="title"> Singapore</span></Link></li>
                                  <li><Link to ='/'> <span class="title">Germany</span></Link></li>
                                    <li><Link to ='/'><span class="title"> Malaysia</span></Link></li>
                                    
                                </ul>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            </div>
      </div>
      </div>        
    )
  }
}

export default Sidebar